/**
 * Created by Jerker Nord on 2018-11-27.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class ThorGameMode extends GameMode {
    public static readonly NUDGE_RESPIN:string = "NUDGE_RESPIN";
    public static readonly SCATTER_RESPIN:string = "SCATTER_RESPIN";
    public static readonly NUDGE_RESPIN_FS:string = "NUDGE_RESPIN_FS";
}